const ua = {
    //login
    greeting: "Якщо ти витрачаєш більше, ніж заробляєш, ти завжди будеш бідним.",
    username: "Ім'я користувача:",
    registration: "РЕЄСТРАЦІЯ",
    log_required: "обов'язково для заповнення",
    pass: "Пароль:",
    in: "УВІЙТИ",
    //registration
    required: "обов'язково для заповнення",
    bevare_name_length: "Ім'я користувача повинно містити не менше 4 символів.",
    bevare_name_matches: "Ім'я користувача може містити тільки латинські літери та цифри.",
    bevare_pass_length: "Пароль не повинен бути меншим за 4 символи.",
    bevare_pass_matches: "Пароль може містити тільки латинські літери та цифри.",
    bevare_pass_check: "Паролі не співпадають.",
    reg_pass: "Пароль:",
    reg_to_log: "ВХІД",
    check_pass: "Повторіть пароль:",
    reg_button: "ЗАРЕЄСТРУВАТИСЯ",
    reg_username: "Ім'я користувача:",
    //logined
    logined_trans_button_text: "Додати",
    logined_trans_list: "СПИСОК ТРАНЗАКЦІЙ:",
    //navbar
    new_transaction: "нова транзакція",
    transaction_statistic: "статистика транзакцій",
    transaction_history: "історія транзакцій",
    calc: "калькулятор",
    //transaction
    transaction_date: "Дата:",
    transaction_amount: "Сума:",
    transaction__details: "Розшифровка: ",
    //transaction form
    tf_data: "Дата:",
    tf_type: "Тип:",
    tf_expence: "Витрата",
    tf_income: "Дохід",
    tf_placeholder_target: "Ціль витрати",
    tf_placeholder_amount: "Сума",
    tf_error: "Нажаль дія не вдалась, спробуте пізніше.",
    tf_complite: "Запис додано",
    //edit transaction
    et_update: "оновити",
    et_cancel: "скасувати",
    //delete transaction
    dt_delete: "Ви бажаєте видалити запис?",
    dt_error: "На жаль, видалення не вдалося, спробуйте пізніше.",
    dt_complite: "Запис видалено",
    //transaction controls
    tr_contrl_oldbegin: "Спочатку старі",
    tr_contrl_newbegin: "Спочатку нові",
    tr_contrl_reload: "Оновити дані",
    tr_contrl_find: "Шуканий тип витрати",
    //summary
    sum_total_income: "Всього дохід:",
    sum_total_expence: "Всього витрата:",
    sum_total_remain: " Залишок:",
    sum_search_in_budget: "Пошук по витратам:",
    sum_search: "Пошук",
    sum_summary_expenses_bytype: "Загальні витрати по типах:",
    expence_by_month: "Витрати по місяцях",
};

export default ua;
